<template>
  <div id="indexMap">
    <div style="display: flex;
    flex-direction: column;width: 100%;height: 100%">
<!--      <div class="d-flex pt-2 pl-2">-->
<!--         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">-->
<!--           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">全景地图</span>-->
<!--        </span>-->
<!--        &lt;!&ndash;          <dv-decoration-1 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />&ndash;&gt;-->
<!--      </div>-->
      <div class="d-flex jc-center band" style="width: 100%;height: 100%">
        <Echart
            id="MapChart"
            ref="Map"
            :options="options"
            height="100%"
            width="100%"
        ></Echart>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options:{},
      myChart:null,
    };
  },
  components: {
    Echart
  },
  computed: {
    cdata() {
      return this.$store.state.cdata
    },
  },
  mounted() {
    this.mapBox()
  },
  methods: {
    //地图样式
    mapBox() {
      let vm = this
      // var datalist = this.cdata
      var geoCoordMap = {
        '万州区': [108.380246,
          30.807807],
        '黔江区': [108.782577,
          29.527548],
        '涪陵区': [107.394905,
          29.703652],
        '渝中区': [106.56288,
          29.556742],
        '大渡口区': [106.48613,
          29.481002],
        '江北区': [106.532844,
          29.575352],
        '沙坪坝区': [106.4542,
          29.541224],
        '九龙坡区': [106.480989,
          29.523492],
        '南岸区': [106.560813,
          29.523992],
        '北碚区': [106.437868,
          29.82543],
        '綦江': [106.651417,
          29.028091],
        '大足区': [105.715319,
          29.700498],
        '易智网': [106.5053749
          , 29.6188842],
        '': [106.5053749
          , 29.6188842],
        '科学城': [106.3425324, 29.5190491],
        '渝东南': [106.651417,
          29.028091],
        '两江协同创新区': [106.8250028, 29.799944],
        '两江新区': [106.5250028, 29.6759554],
        '渝北': [106.712851,
          29.899944],
        '巴南': [106.519423,
          29.381919],
        '长寿': [107.074854,
          29.833671],
        '江津区': [106.253156,
          29.283387],
        '合川区': [106.265554,
          29.990993],
        '永川区': [105.894714,
          29.348748],
        '南川区': [107.098153,
          29.156646],
        '璧山区': [106.231126,
          29.593581],
        '铜梁': [106.054948,
          29.839944],
        '潼南': [105.841818,
          30.189554],
        '荣昌区': [105.594061,
          29.403627],
        '梁平': [107.800034,
          30.672168],
        '武隆区': [107.75655,
          29.32376],
        '城口县': [108.6649,
          31.946293],
        '丰都县': [107.73248,
          29.866424],
        '垫江县': [107.348692,
          30.330012],
        '忠县': [108.037518,
          30.291537],
        '云阳县': [108.697698,
          30.930529],
        '奉节县': [109.465774,
          31.019967],
        '巫山县': [109.878928,
          31.074843],
        '巫溪县': [109.628912,
          31.3966],
        '石柱县': [108.112448,
          29.99853],
        '秀山县': [108.996043,
          28.444772],
        '酉阳县': [108.767201,
          28.839828],
        '彭水县': [108.166551,
          29.293856],
        '开州': [108.3999240, 31.1668463],
      }
      var Data = [
        [{
          name: '易智网'
        }, {
          name: "两江协同创新区",
          value: 99,
        }],
        [{
          name: '易智网'
        }, {
          name: "科学城",
          value: 99,
        }],
        [{
          name: '易智网'
        },
          {
            name: "巴南",
            value: 99
          },
        ],
        [{
          name: '易智网'
        },
          {
            name: "渝北",
            value: 99
          },],
        [{
          name: '易智网'
        },
          {
            name: "两江新区",
            value: 99
          },],
        [{
          name: '易智网'
        },
          {
            name: "开州",
            value: 99
          },],
        [{
          name: '易智网'
        },
          {
            name: "潼南",
            value: 99
          },],
        [{
          name: '易智网'
        },
          {
            name: "渝东南",
            value: 99
          },],
        [{
          name: '易智网'
        },
          {
            name: "铜梁",
            value: 99
          },
        ],
        [{
          name: '易智网'
        },
          {
            name: "万州区",
            value: 99
          },
        ],
      ]
      // var Bata=[
      //   [{
      //     name: '渝中区'
      //   }, {
      //     name: "渝中区",
      //     value:100
      //   }],
      //   [{
      //     name: '渝中区'
      //   }, {
      //     name: "江北区",
      //     value: 100
      //   }],
      //   [{
      //     name: '渝中区'
      //   }, {
      //     name: "沙坪坝区",
      //     value: 100
      //   }],
      // ]
      //var planePath = 'path://M.6,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705';
//var iconR='image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNCRkRBMEJBQzgwRjExRUFBNUI0RTMyMThEN0UxMzFEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjNCRkRBMEJCQzgwRjExRUFBNUI0RTMyMThEN0UxMzFEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6M0JGREEwQjhDODBGMTFFQUE1QjRFMzIxOEQ3RTEzMUQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0JGREEwQjlDODBGMTFFQUE1QjRFMzIxOEQ3RTEzMUQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5mT42iAAABQ0lEQVR42mL8LabOQCQIBOL1xChkItJAkLp+IBajpqFWQCwPxJ7UNDQCSgdQy1BmIA6Bsl2AmJMahjoAsTiUzQPETtQwNAKN709IAwvUayZQ/hcg/o0k/x6Ig9D0+ABxKJT9HYh/oMm/BBm6GYitgTgfiBmJcLkkEK/CIXcGiGNB3v8JxIVQF31gIA/8AeIWaNK7gRymG4BYH4hPkGjgXSC2A+JaWNChR9QjqIJeIP5PhIGzgdgAiI8Tin2QbSVAvIOAgROBOA0auUQlKV4gtidgqBGp6RSUFrmIKA/ESDEUPcGfBOIUIH6Lln29iTVUCIjdkJJKExDbAPFcqJdPEMpd2AwF5TBWaFKxBeJ6qOHIqaMbmjrcsBUw2AwNh7rKAEeaBaWOMiD2BeJvQOxOyFBuaFJJwZZU0MBWaHCIo0sABBgAetA4Jx5t/ToAAAAASUVORK5CYII='

      // var convertData = function (data) {
      //   var res = [];
      //   for (var i = 0; i < data.length; i++) {
      //     var dataItem = data[i];
      //     var fromCoord = geoCoordMap[dataItem[0].name];
      //     var toCoord = geoCoordMap[dataItem[1].name];
      //     if (fromCoord && toCoord) {
      //       res.push([{
      //         coord: fromCoord
      //       }, {
      //         coord: toCoord
      //       }]);
      //     }
      //   }
      //   return res;
      // };
      var series = [];
      [['易智网', Data]].forEach(function (item) {
        series=[   {
          name: item[0],
          type: 'effectScatter',
          coordinateSystem: 'geo',
          symbolSize: 10,
          rippleEffect: { //坐标点动画
            brushType: 'fill',
            scale:5,
            color: '#ffa022'
          },
          label: {
            normal: {
              show: true,
              position: 'right',
              formatter: '{b}分支基地',
            }
          },
          itemStyle: {
            normal: {
              color: '#fff',
              fontSize:16
            },
            emphasis: {
              show:true,
              areaColor: '#4c9bfd',
              borderColor: '#5cd9e8',
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
            }
          },
          data: item[1].map(function (dataItem) {
            return {
              name: dataItem[1].name,
              value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
            };
          })
        }]
      });
      let options = {
        // showLegendSymbol: true,
        tooltip: {
          show:false,
          trigger: 'item',
          backgroundColor:'#efefef',
          textStyle:{
            color:'#4c9bfd',
            fontSize: 18
          },
          // formatter: "{b}<br/>分站点",
          // position: point => {
          //   // 固定在顶部
          //   return [point[0] + 50, point[1] - 20];
          // },
          // 如果需要自定义 tooltip样式，需要使用formatter
          // formatter: params => {
          //   `<div id="plan">
          // <h4 style="margin:16px;font-size:18px;font-weight:normal;color:#fff;">${params.name}</h4>
          // <ul style="margin:16px;color:#fff;">
          // <li style="color:rgba(201,201,201,0.7);font-size:12px"><span>高企：</span>   <span style="color:#439aff;font-size:18px">${params.data.highTechFirm}</span><span>家</span></li>
          // </ul>
          // </div>`
          // },
          // formatter: '{b}<br/>企业{c}家'
        },
        geo: {
          map: '重庆市',
          type:'map',
          mapType:'重庆市',
          layoutCenter: ['50%', '50%'],
          layoutSize: '100%',
          aspectScale: 0.85,
          roam:true,
          label: {
            emphasis: {
              show: true,
              color:'#fff'
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#142957',
              borderColor: '#0692a4',
              borderWidth:2
            },
            emphasis: {
              show:true,
              areaColor: '#4c9bfd',
              borderColor: '#5cd9e8',
              borderWidth:3,
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
            }
          }

        },
        series: series
      };
      this.myChart = this.$echarts.init(document.getElementById('MapChart'))
      this.myChart.setOption(options, true);
      //点击地图
      this.myChart.on("click", function (params) {
        vm.typeList = params
        //传值给主屏
        vm.$store.commit('setypeList', vm.typeList)

        vm.myChart.dispatchAction({
          type: 'mapUnSelect',
          seriesIndex: 0,
          dataIndex: vm.preSelectMapIndex,
        });
        vm.myChart.dispatchAction({
          type: 'mapSelect',
          seriesIndex: 0,
          dataIndex: params.dataIndex,
        });
        vm.preSelectMapIndex = params.dataIndex;
      });

    }
  }
};
</script>

<style lang="scss">
.band{
  flex: 1;
}
#indexMap {
  height:100%;
  width: 100%;
  //border-radius: 0.0625rem;
  //.bg-color-black {
  //  height: 4.8125rem;
  //  border-radius: 0.125rem;
  //}
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>